export default __webpack_public_path__ + "static/media/broker-template-2.75e56660.svg";